import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { updateExtraStorage } from '@custom/rtk-apis/Setting/extraStorage/updateExtraStorage';

interface ExtraStorageState {
  result: any;
  loading: boolean;
  error: string | null;
  success: boolean;
  status: string | null;
}

const initialState: ExtraStorageState = {
  result: null,
  loading: false,
  error: null,
  success: false,
  status: null,
};

const updateExtraStorageSlice = createSlice({
  name: 'updateExtraStorage',
  initialState,
  reducers: {
    resetUpdateExtraStorage: (state) => {
      state.result = null;
      state.loading = false;
      state.error = null;
      state.success = false;
    },
    resetSuccess: (state) => {
      state.success = false;
    },
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateExtraStorage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateExtraStorage.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.result = action.payload;
        state.success = true;
        state.status = 'SUCCESS';
      })
      .addCase(updateExtraStorage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
        state.status = 'FAILED';
      });
  },
});

export default updateExtraStorageSlice.reducer;
export const { resetUpdateExtraStorage, resetSuccess, resetError } = updateExtraStorageSlice.actions;
